export default __webpack_public_path__ + "static/media/paris_.3c78bd37.mp4";